export default {
	text: "{changedBy} updated the value of KR <a href='#' data-action='key-result'>{name}</a> from {from} to {to}",
};
